"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.objekt_gefahr_nichtbefahrbar = void 0;
const leaflet_1 = __importDefault(require("leaflet"));
exports.objekt_gefahr_nichtbefahrbar = leaflet_1.default.icon({
    iconUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEVSURBVFhH7dehaoVwFMfxwxAmykQUbQYFtQwMNzmfwKJvMAThsmgxuXhvuWV9VR/gNptYNFlNPsPk4tJMu8qJYhwL51f+8OEg3yrQ9hbH8dX3/bYoik8kyLKsXexyuZyQIEmSkyRJbRAELRKcz+e35S6KoivS5h7w3VzTNIeyLN1hGJ6RoOs6d7G+7y0kmOfZGsfRnabJRQKGYV6Xu7quD0ib2w34i1EABVAABVAABVAABVAABVAABewGGIYBtm2DLMsoADzPgyAIwHEcCoCqquudpmkoAKIorrZ8Y28MvptL0zS83W6Ppml+I4FlWS/33zDQdf0LCcIwfHcc50NRFMjzfDXP8473sCeWZX+qqlrtHw7gF5j6S1xxdbTcAAAAAElFTkSuQmCC",
    iconSize: [32, 32],
});
